import clsx from 'clsx'
import { ChatContentProps } from './ChatMessageContent'
import { FormattedText } from '../../../components'

// TODO: Add WhatsApp text formatter
export function ChatMessageContentText (props: ChatContentProps) {
  const { content, className } = props

  return (
    <div className={clsx(className, 'text-sm px-1')}>
      <FormattedText text={content}/>
    </div>
  )
}
